<template>
    <div>
        <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>
  
<script>
import VueApexCharts from 'vue-apexcharts';
  
export default {
    name: 'BarChart',
    components: {
        apexchart: VueApexCharts
    },
    props: {
        series: {
            type: Array,
            required: true,
            default: () => [{
                name: '',
                data: [0]
            }]
        },
        categories: {
            type: Array,
            default: () => []
        },
        colors: {
            type: Array,
            default: () => ['#ad88f1']
        },
        height: {
            type: Number,
            default: 350
        },
        isHorizontal: {
            type: Boolean,
            default: true
        },
        isStacked: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        chartOptions() {
            // Opciones base del gráfico
            const baseOptions = {
                chart: {
                    type: 'bar',
                    height: this.height,
                    stacked: this.isStacked,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: this.isHorizontal,
                        borderRadius: 4,
                        columnWidth: '70%',
                        dataLabels: {
                            position: this.isHorizontal ? 'center' : 'top'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function(val) {
                        return val.toString();
                    },
                    style: {
                        fontSize: '12px'
                    }
                },
                xaxis: {
                    categories: this.categories,
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                colors: this.colors,
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                },
                tooltip: {
                    enabled: true,
                    shared: true, // Habilitar tooltip compartido
                    intersect: false, // Deshabilitar intersect
                    style: {
                        fontSize: '12px'
                    }
                }
            };

            // Opciones adicionales para gráficos apilados
            if (this.isStacked) {
                baseOptions.plotOptions.bar = {
                    ...baseOptions.plotOptions.bar,
                    borderRadius: 4,
                    dataLabels: {
                        total: {
                            enabled: true,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    }
                };
                
                baseOptions.fill = {
                    opacity: 1
                };
            }

            return baseOptions;
        }
    }
};
</script>